<template>
  <div
    v-if="config.env !== 'production'"
    class="fixed right-4 z-50 flex flex-col gap-1 bg-black/80 text-white text-xs p-3 rounded transition-all duration-300"
    :style="{ bottom: devToolsBottom }"
  >
    <span class="font-bold mb-1">Dev Tools</span>

    <div class="flex gap-1 flex-wrap">
      <button
        v-for="(step, i) in PlanWorkflowStepOrder"
        :key="step"
        class="px-1.5 py-0.5 rounded"
        :class="workflowStep === step ? 'bg-blue-500' : 'bg-white/20 hover:bg-white/40'"
        @click="workflowStep = step"
      >
        {{ i + 1 }}
      </button>

      <span class="opacity-40 ml-1">a/d ← →</span>
    </div>

    <div class="flex gap-1 flex-wrap mt-1">
      <button
        v-for="(role, i) in roles"
        :key="role"
        class="px-1.5 py-0.5 rounded"
        :class="authStore.user?.roles?.includes(role) ? 'bg-blue-500' : 'bg-white/20 hover:bg-white/40'"
        @click="authStore.user.roles = [role]"
      >
        {{ i + 1 }} {{ role.split(' ')[0] }}
      </button>
    </div>

    <div class="flex gap-1 flex-wrap mt-1">
      <button
        class="px-1.5 py-0.5 rounded"
        :class="authStore.currentMunicipality?.archived ? 'bg-blue-500' : 'bg-white/20 hover:bg-white/40'"
        @click="authStore.currentMunicipality.archived = !authStore.currentMunicipality?.archived"
      >
        Archived
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, onUnmounted } from 'vue';

import config from '@/config';
import { useAuthStore, useToastStore } from '@/store';
import { PlanWorkflowStepOrder } from '@/const';

const workflowStep = defineModel({ type: String, required: true });

const authStore = useAuthStore();
const toastStore = useToastStore();

const roles = ['System Administrator', 'Municipal Administrator', 'IDP Officer', 'Viewer'];

// 32px toast container base + ~54px per toast
const devToolsBottom = computed(() => {
  const count = toastStore.toasts.length;
  return count ? `${32 + count * 54}px` : '16px';
});

const nextStep = (step) => {
  const index = PlanWorkflowStepOrder.indexOf(step);
  return index >= 0 && index < PlanWorkflowStepOrder.length - 1 ? PlanWorkflowStepOrder[index + 1] : step;
};

const prevStep = (step) => {
  const index = PlanWorkflowStepOrder.indexOf(step);
  return index > 0 ? PlanWorkflowStepOrder[index - 1] : step;
};

const onKeyDown = (e) => {
  if (e.key === 'd' || e.key === 'ArrowRight') workflowStep.value = nextStep(workflowStep.value);
  if (e.key === 'a' || e.key === 'ArrowLeft') workflowStep.value = prevStep(workflowStep.value);
  const roleIndex = ['1', '2', '3', '4'].indexOf(e.key);
  if (roleIndex !== -1) authStore.user.roles = [roles[roleIndex]];
};

onMounted(() => window.addEventListener('keydown', onKeyDown));
onUnmounted(() => window.removeEventListener('keydown', onKeyDown));
</script>
